// @flow
import { lighten, darken } from 'polished';

import { createGeneratorBsButtonColors, getContrastColor } from '../mixins';
import type { Theme } from '../types';

export const createTheme = (parentTheme: Theme, newTheme: Object): Theme => {
  const lights = { ...parentTheme.lights, ...newTheme.lights };

  const colors = { ...parentTheme.colors, ...newTheme.colors };

  const brandColors = { ...parentTheme.brandColors, ...newTheme.brandColors };

  const brandLightenColors = Object.keys(brandColors).reduce(
    (acc, i) => ({ ...acc, [`${i}Light`]: lighten(lights.mainAmountOfLight, brandColors[i]) }),
    {},
  );

  const brandDarkenColors = Object.keys(brandColors).reduce(
    (acc, i) => ({ ...acc, [`${i}Dark`]: darken(lights.mainAmountOfLight, brandColors[i]) }),
    {},
  );

  const grayColors = { ...parentTheme.grayColors, ...newTheme.grayColors };

  const bsColors = {
    ...brandColors,
    ...brandLightenColors,
    ...brandDarkenColors,
    ...grayColors,
  };

  const body = {
    ...parentTheme.body,
    ...newTheme.body,
  };

  const generateBtnColors = createGeneratorBsButtonColors(
    getContrastColor(bsColors.grayDark, bsColors.white),
    lights.borderAmountOfLight,
  );

  const buttons = {
    ...generateBtnColors('Default', bsColors.white, bsColors.grayLight),
    ...generateBtnColors('Primary', bsColors.brandPrimary),
    ...generateBtnColors('Info', bsColors.brandInfo),
  };

  const sizes = {
    ...parentTheme.sizes,
    ...newTheme.sizes,
  };

  const images = {
    ...parentTheme.images,
    ...newTheme.images,
  };

  return {
    ...parentTheme,
    ...newTheme,
    ...lights,
    ...bsColors,
    ...body,
    ...buttons,
    ...sizes,
    ...images,
    lights,
    colors,
    brandColors,
    grayColors,
    body,
    sizes,
    images,
  };
};

export default createTheme;



// WEBPACK FOOTER //
// ./src/themes/utils/createTheme.js